define([
    "dijit/focus",
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/on",
    "dojo/Evented",
    "dojo/keys",
    "MW/GridPicker",
    "MW/toolstrip/form/DropDownButton",
    "mw-form/Menu",
    "mw-dom-utils/domUtils"
], function (focus, declare, lang, on, Evented, keys, GridPicker,
             DropDownButton, Menu, domUtils) {

    return declare([DropDownButton, Evented], {

        baseClass: "mwWidget mwDropDownButton mwGridPickerButton",
        visualFamily: "default",

        maxRows: 5,
        maxColumns: 5,
        occupancy: 0,
        fillOrder: "rowMajor",

        constructor: function (args) {

            args = args || {};
            this.maxRows = args.maxRows ? args.maxRows : this.maxRows;
            this.maxColumns = args.maxColumns ? args.maxColumns : this.maxColumns;
            this.occupancy = args.occupancy ? args.occupancy : this.occupancy;
            this.fillOrder = args.fillOrder ? args.fillOrder : this.fillOrder;

            this._gridPicker = new GridPicker({
                maxRows: this.maxRows,
                maxColumns: this.maxColumns,
                occupancy: this.occupancy,
                fillOrder: this.fillOrder
            });

            this._gridPickerMenu = new Menu();

            this.selection = {};

            this.own(this._gridPicker);
            this.own(this._gridPickerMenu);
        },

        buildRendering: function () {
            this.inherited(arguments);
            this._gridPickerMenu.addChild(this._gridPicker);
            this.set("menu", this._gridPickerMenu);
        },

        _setSelectionAttr: function (selection) {
            if(Object.keys(selection).length !== 0) {
                if (this._gridPicker.getLastSelectedRowCount() !== selection.row && this._gridPicker.getLastSelectedColumnCount() !== selection.column) {
                    this._gridPicker.highlightCells(selection.row - 1, selection.column - 1);
                }
            }
            this._set("selection", selection);
        },

        _setMaxRowsAttr: function (value) {
            if (this._created) {
                throw new Error("Max Rows can only be set at construction time");
            } else {
                this._set("maxRows", value);
            }
        },

        _setMaxColumnsAttr: function (value) {
            if (this._created) {
                throw new Error("Max Columns can only be set at construction time");
            } else {
                this._set("maxColumns", value);
            }
        },

        _setOccupancyAttr: function (value) {
            this._gridPicker.set("occupancy", value);
            this._set("occupancy", value);
        },

        _setFillOrderAttr: function (value) {
            this._gridPicker.set("fillOrder", value);
            this._set("fillOrder", value);
        },

        postCreate: function () {
            this.inherited(arguments);
            this._gridPicker.on(GridPicker.SELECTION_CHANGED, this._handleGridSelection.bind(this));
            this.menu.on("keydown", this._handleMenuKeyDown.bind(this));
            this.menu.on("open", this._handleMenuCloseOnFocusOut.bind(this));
        },

        /**
         * This function sets the 'selection' property whenever gridpicker emits 'gridSelectionChanged' event
         * and subsequently closes the menu
         * @param event
         * @private
         */
        _handleGridSelection: function (event) {
            var selection = {};
            selection.row = event.rows;
            selection.column = event.columns;

            this.set("selection", selection);
            this.closeMenu();
        },

        /**
         * This function handles the closing of menu when a gridPicker cell is in focus and
         * mouse click target is not a descendant of menu. This is needed because the blur event
         * on clicking outside the menu is not bubbled up and the menu does not close. Therefore,
         * explicitly watching for focus change events and closing the menu accordingly.
         * @private
         */
        _handleMenuCloseOnFocusOut: function () {
            // Watch for focus change
            var handle = focus.watch("curNode", lang.hitch(this, function (name, oldValue, newValue) {

                //If click target not a descendant of menu, then stop watching and close menu
                if (newValue === null || !domUtils.findParentNode(newValue, "mwMenu")) {
                    handle.unwatch();
                    this.closeMenu();
                }
            }));

            this.own(handle);
        },

        /**
         * This function is responsible for handling keyboard navigation
         * @param event
         * @private
         */
        _handleMenuKeyDown: function (event) {
            if (event.keyCode === keys.TAB) {
                //to prevent menu from closing on hitting the tab key
                event.stopPropagation();
            }

            this._gridPicker.navigate(event);
        }
    });
});
